import React, { useState } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string } from 'prop-types'

// The answer stays in the DOM while collapsed (clipped by CSS, not unmounted) so it is
// present in the server HTML -- both for the FAQPage structured data emitted alongside
// these pages and because Google requires the answer text to be in the initial markup.
function Item({ idPrefix, index, question, answer, defaultOpen = false, showDivider = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const handleToggle = () => setIsOpen((open) => !open)

  const questionId = `${idPrefix}-question-${index}`
  const answerId = `${idPrefix}-answer-${index}`

  return (
    <div className="ai-landing-faqs__item">
      <div className="ai-landing-faqs__content">
        <button
          type="button"
          id={questionId}
          className="ai-landing-faqs__question"
          aria-expanded={isOpen}
          aria-controls={answerId}
          onClick={handleToggle}
        >
          <span className="ai-landing-faqs__question-text cgt-heading-200">{question}</span>
          <span
            className={classnames('ai-landing-faqs__icon', isOpen && 'ai-landing-faqs__icon--open')}
            aria-hidden
          >
            <span className="ai-landing-faqs__icon-bar ai-landing-faqs__icon-bar--horizontal" />
            <span className="ai-landing-faqs__icon-bar ai-landing-faqs__icon-bar--vertical" />
          </span>
        </button>
        <div
          className={classnames(
            'ai-landing-faqs__answer-wrap',
            isOpen && 'ai-landing-faqs__answer-wrap--open',
          )}
        >
          <div className="ai-landing-faqs__answer-clip">
            <p
              id={answerId}
              role="region"
              aria-labelledby={questionId}
              aria-hidden={!isOpen}
              className="ai-landing-faqs__answer cgt-body-md"
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
      {showDivider && <div className="ai-landing-faqs__divider" />}
    </div>
  )
}

Item.propTypes = {
  idPrefix: string.isRequired,
  index: number.isRequired,
  question: string.isRequired,
  answer: string.isRequired,
  defaultOpen: bool,
  showDivider: bool,
}

export default Item
